module.exports = __webpack_public_path__ + "static/media/header-3.0bf6fe84.jpg";